import { FC } from 'react';
import { parseProductTypeByLoanFormat, ProductType } from '../../../models/ProductType';
import { LoanFormat, mapLoanFormatToUrl, parseLoanFormat } from '../../../models/LoanFormat';
import { Redirect, useParams } from 'react-router';
import { PageNotFound } from '../PageNotFound';

export const CheckLoanFormatAndProductType: FC<{
    children: FC<{ productType: ProductType; loanFormat: LoanFormat }>;
}> = ({ children }) => {
    const { productType: productTypeParam, loanFormat: loanFormatParam } = useParams<{
        productType: string;
        loanFormat: string;
    }>();

    const loanFormat = parseLoanFormat(loanFormatParam);
    const productType = parseProductTypeByLoanFormat(loanFormat, productTypeParam);

    if (loanFormat && !productType) {
        return <Redirect to={`/catalogue/${mapLoanFormatToUrl(loanFormat)}/featured`} />;
    } else if (loanFormat && productType) {
        return children({ loanFormat, productType });
    } else {
        return <PageNotFound />;
    }
};
